(function (global) {
  'use strict';

  global.Reverb = global.Reverb || {};

  function getNavOffset() {
    var $bodyWrapper = $('.body-wrapper');
    if (!$bodyWrapper.length) { return 0; }
    return 0 + $bodyWrapper.css('margin-top').replace('px', '');
  }

  function scroll(target, callback) {
    var $target = $(target);
    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - getNavOffset()
      }, 300);
      return callback;
    }
  }

  global.Reverb.SmoothScroll = { scroll: scroll };
})(window);

(function () {
  'use strict';

  function doScroll(that, callback) {
    var isPathname = location.pathname.replace(/^\//, '') === that.pathname.replace(/^\//, ''),
      isHostname = location.hostname === that.hostname;
    var target;

    if (isPathname || isHostname) {

      target = $(that.hash);
      target = target.length ? target : $('[name=' + that.hash.slice(1) + ']');
      return Reverb.SmoothScroll.scroll(target, callback);
    }
  }

  $('[data-smooth-scroll]').click(function () {

    // this returns false, preventing default actions
    return doScroll(this, false);
  });

  $('[data-smooth-scroll-and-continue]').click(function () {

    // this returns true, allowing events to continue
    // useful for allowing additional actions such as
    // hiding/showing elements
    return doScroll(this, true);
  });
})();



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dom/smooth_scrolling.js